import { collection, onSnapshot } from 'firebase/firestore';
import { db } from '@/firebaseInit';
import { coll_bookingRequestNotes, type BookingRequestNotesType } from '@/types/types_bookingRequest';

// Data access for the desk's private notes on booking requests. Reads only, and
// admins only — the rules refuse this collection to everyone else, which is what
// makes an "internal" note actually internal.
//
// Writes go through `setBookingRequestStatus` with the offer the note was
// entered on, so a note and the date it was written about commit together.

const bookingRequestNotesCollection = collection(db, coll_bookingRequestNotes);

/**
 * Subscribes to every internal note, keyed by the request it belongs to.
 *
 * A map rather than a list because that is how the queue reads them — one lookup
 * per row — and unfiltered because there is one document per request that has a
 * note, which is a fraction of a queue that is already small enough to subscribe
 * to whole.
 *
 * Ordering is absent on purpose: these are looked up, never listed.
 */
export function subscribeBookingRequestNotes(
  onChange: (notes: Map<string, BookingRequestNotesType>) => void,
  onError?: (error: Error) => void,
): () => void {
  return onSnapshot(
    bookingRequestNotesCollection,
    (snap) => onChange(
      new Map(
        snap.docs.map((d) => [d.id, { ...(d.data() as Omit<BookingRequestNotesType, 'id'>), id: d.id }]),
      ),
    ),
    onError,
  );
}
